module.exports = __webpack_public_path__ + "3f16e137/img/send-icon.3cfb6275.svg";